<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre_25" id="filepos71428"><span class="calibre10"><span class="italic1">7 <img alt="image" class="calibre11" src="images/00004.jpg"/> Le Fantoche</span></span></h2><div class="calibre_14"> </div>
<p class="calibre_18"><span class="calibre5">If one seeks to rid oneself of, or even to transcend, a false self, ego, or personality, one thereby accepts as a fact the existence of such entity and so-doing affirms its stranglehold (a constraint can be real or imaginary—such as that of the chicken’s beak held by a chalk-line).</span></p>
<p class="calibre_19"><span class="calibre5">That of which we need to rid ourselves, to transcend, is the false concept whereby we assume that entity’s existence. We have only to look with penetration in order to perceive that there is in fact nothing in us which corresponds to the concept of an entity, in our ever-changing kaleidoscope of electronic impulses interpreted in the false perspective of a time-sequence. A pulsating force-field is not an entity to be transcended, any more than is vapour issuing from the spout of a kettle, or the apparently living being resulting from the rapid and consecutive projection of isolated and motionless “stills” (or quanta) on to a cinematograph screen.</span></p>
<p class="calibre_19"><span class="calibre5">There is not, there could not be, any entity; the Buddha based his doctrine upon that realisation; there can be nothing <a></a>of which to rid ourselves, or to transcend, except an erroneous concept. . . .</span></p> <div class="mbp_pagebreak" id="calibre_pb_29"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_017.vue?77715e75